// extracted by mini-css-extract-plugin
export default {"button":"login_button__vx+8U","logo":"login_logo__8363s","colfix":"login_colfix__wbftj"};